import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import AwardingList from './components/AwardingList';

const AwardingPage = () => {
  document.title = 'Awarding';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumb listClassName='p-3 py-2 bg-light'>
            <BreadcrumbItem>
              <Link to='/dashboard'>Home</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>Awarding</BreadcrumbItem>
          </Breadcrumb>

          <AwardingList />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AwardingPage;
